/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Top_Up_PayInputs */

const cs_billing_top_up_pay = /** @type {(inputs: Billing_Top_Up_PayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokračovat k platbě`)
};

const en_billing_top_up_pay = /** @type {(inputs: Billing_Top_Up_PayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue to payment`)
};

/**
* | output |
* | --- |
* | "Continue to payment" |
*
* @param {Billing_Top_Up_PayInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_top_up_pay = /** @type {((inputs?: Billing_Top_Up_PayInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Top_Up_PayInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_top_up_pay(inputs)
	return cs_billing_top_up_pay(inputs)
});